'use strict';
(() => {
  function chooseRecommendationItems(items, requestedCount, previousIds = [], currentId = '', random = Math.random) {
    const count = Math.max(1, Math.min(8, Math.floor(Number(requestedCount) || 4)));
    const excluded = String(currentId);
    const seen = new Set();
    const candidates = [];
    for (const item of Array.isArray(items) ? items : []) {
      const id = item?.id == null ? '' : String(item.id);
      if (!id || id === excluded || seen.has(id) || item.available === false) continue;
      seen.add(id);
      candidates.push({...item, id});
    }
    const previous = new Set((Array.isArray(previousIds) ? previousIds : []).map(String));
    const shuffle = list => {
      const result = [...list];
      for (let index = result.length - 1; index > 0; index--) {
        const sample = Number(random());
        const normalized = Number.isFinite(sample) ? Math.max(0, Math.min(.999999999999, sample)) : 0;
        const other = Math.floor(normalized * (index + 1));
        [result[index], result[other]] = [result[other], result[index]];
      }
      return result;
    };
    const fresh = shuffle(candidates.filter(item => !previous.has(item.id)));
    const repeated = shuffle(candidates.filter(item => previous.has(item.id)));
    return [...fresh, ...repeated].slice(0, count);
  }

  function readRecommendationHistory(key) {
    try {
      const value = JSON.parse(window.sessionStorage.getItem(key) || '[]');
      return Array.isArray(value) ? value.filter(id => typeof id === 'string' || typeof id === 'number').slice(0, 8).map(String) : [];
    } catch {
      return [];
    }
  }

  function writeRecommendationHistory(key, ids) {
    try { window.sessionStorage.setItem(key, JSON.stringify(ids)); } catch {}
  }

  const existing = window.__idolnestRecommendationsV1;
  if (existing) { existing.init(document); return; }
  const instances = new Map();
  const selector = '[data-in-recommendations]';

  function rotate(instance) {
    const {host, grid, items, key} = instance;
    if (!host.isConnected || host.dataset.recommendationShuffle === 'false') return;
    if (host.contains(document.activeElement) && document.activeElement?.matches?.(':focus-visible')) return;
    const storedPrevious = readRecommendationHistory(key);
    const previous = storedPrevious.length ? storedPrevious : instance.previous || [];
    const avoid = previous.length ? previous : instance.initialIds;
    const selected = chooseRecommendationItems(items, host.dataset.recommendationCount, avoid, host.dataset.currentProduct);
    if (!selected.length) { host.hidden = true; return; }
    const fragment = document.createDocumentFragment();
    for (const item of selected) fragment.append(item.node.cloneNode(true));
    grid.replaceChildren(fragment);
    host.hidden = false;
    instance.previous = selected.map(item => item.id);
    host.dataset.recommendationIds = instance.previous.join(',');
    host.dataset.recommendationRevision = String(Number(host.dataset.recommendationRevision || 0) + 1);
    writeRecommendationHistory(key, instance.previous);
  }

  function init(scope = document) {
    for (const host of instances.keys()) if (!host.isConnected) instances.delete(host);
    const hosts = scope.matches?.(selector) ? [scope] : [...scope.querySelectorAll(selector)];
    for (const host of hosts) {
      if (instances.has(host) || host.dataset.recommendationShuffle === 'false') continue;
      const grid = host.querySelector('[data-in-recommendation-grid]');
      const pool = host.querySelector('[data-in-recommendation-pool]');
      if (!grid || !pool) continue;
      const visible = [...grid.querySelectorAll('[data-in-card-id]')];
      const all = [...visible, ...pool.content.querySelectorAll('[data-in-card-id]')];
      const items = all.map(node => ({id: node.dataset.inCardId, available: node.dataset.inCardAvailable !== 'false', node: node.cloneNode(true)}));
      const key = ['idolnest:recommendations:v1', host.dataset.recommendationCollection || '', host.dataset.recommendationSection || '', host.dataset.currentProduct || ''].map(encodeURIComponent).join(':');
      const instance = {host, grid, items, key, previous: null, initialIds: visible.map(node => String(node.dataset.inCardId))};
      instances.set(host, instance);
      rotate(instance);
    }
  }

  window.__idolnestRecommendationsV1 = {init};
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const host of instances.keys()) if (host === event.target || event.target.contains(host)) instances.delete(host);
  });
  window.addEventListener('pageshow', event => {
    if (!event.persisted) return;
    for (const instance of instances.values()) rotate(instance);
  });
})();
